import React from 'react';

const Error = () => {
    return (
        <div>
            <p className='text-center'>Sever error! 404</p>
        </div>
    );
};

export default Error;